<template>
  <card-item card="item_status" :tabs="tabs" v-model="activeTab" :id="`${id}${$store.state.user.sections['statuses'] ?  '' : '000030003'}`">

  </card-item>
</template>
<script>
export default {
  methods: {
  },
  props: ["id"],
  data() {
    return {
      tabs: [
        {
          title: "Информация", key: 'info',
          component: () => import("./Info"),
        }
      ],
      activeTab: 0,
    };
  },
};
</script>